/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { LicensedHardwareDTO } from "../models/licensed-hardware-dto";
import { LicensingService } from "../services/licensing.service";
import { Input, Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class LicensedHardwaresResolver implements Resolve<LicensedHardwareDTO[]> {

  constructor(
    private mLicensingService: LicensingService
  ) {}

  async resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<LicensedHardwareDTO[]> {
    try {
      return await this.mLicensingService.getAvailableHardware();
    } catch (error) {
      console.error("Problem resolving Licensed Hardwares.", error);
    }
  }

}
